import { defineMessages } from 'react-intl';

const messages = defineMessages({
  fieldsRequired: {
    id: 'fieldsRequired',
    defaultMessage: 'All fields are required',
  },
});

export default messages;
